import React ,{ PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';

class RestaurantError extends React.Component {
  // todo something is wrong in this props
  static propTypes = {
    lang: PropTypes.string,
    next: PropTypes.object,
    restaurant: PropTypes.string,
    view: PropTypes.string,
    view_info: PropTypes.func
  };


  componentDidMount() {
    this.lang = this.props.next.params.lang;
    this.restaurant = this.props.next.params.restaurant;

    if(this.props.view === 'api') {
      this.lang = this.props.lang;
      this.restaurant = this.props.restaurant;
    }

    // Sending view info to Restaurant.js to feed the Top and Bottom bars
    this.props.view_info(
      //title
      'Pickly',
      //view
      'error',
      //back button or not
      true
    );
  }

  render() {
    let anchor_url = '';

    if(this.props.restaurant === '') {
      anchor_url = 'https://picklyapp.com/';
    } else {
      anchor_url = '/' + this.lang + `/${this.restaurant}`;
    }

    return (
      <div>
        <div className="restaurant-error error-wrapper">
          <div className="error-content">
            <FormattedMessage id="error_home_title1">
              {(message) => <h2>{message}</h2>}
            </FormattedMessage>
            <FormattedMessage id="error_home_title2">
              {(message) => <h4>{message}</h4>}
            </FormattedMessage>
            <FormattedMessage id="error_home_text">
              {(message) => <p>{message}</p>}
            </FormattedMessage>
            <a className="btn secondary-btn big-btn"
               href={anchor_url}>
              <FormattedMessage id="error_home_link">
                {(message) => <span>{message}</span>}
              </FormattedMessage>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default RestaurantError;



/** WEBPACK FOOTER **
 ** ./src/components/RestaurantError.js
 **/